module.exports = __webpack_public_path__ + "img/canais-pay-tv.52490e4c.png";